import { render, staticRenderFns } from "./EditPropertyPermissionsList.vue?vue&type=template&id=4b269d26&"
import script from "./EditPropertyPermissionsList.vue?vue&type=script&lang=js&"
export * from "./EditPropertyPermissionsList.vue?vue&type=script&lang=js&"
import style0 from "./EditPropertyPermissionsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VContainer})
